import React, { useState } from "react";
import { Form, Button, Message, Loader } from "semantic-ui-react";
import { authAPI } from "../api";
import { showNotification } from "../utils/notifications";

export default function LoginForm({ onLoginSuccess }) {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Reset dell'errore quando l'utente digita
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await authAPI.login(formData.email, formData.password);

      // check if there are already logged in users
      if (response.otherLoggedUsers && response.otherLoggedUsers.length > 0) {
        const userList = response.otherLoggedUsers.join(", ");
        showNotification(
          `Attenzione: ci sono altri utenti collegati: ${userList}`,
          true,
          10000
        );
        onLoginSuccess(response.user);
      } else {
        onLoginSuccess(response.user);
      }
    } catch (error) {
      setError(error.message || "Errore durante il login");
      showNotification(error.message || "Errore durante il login", true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img
          src="./labcare-favicon-512.png"
          alt="Logo"
          width="120"
          height="120"
        />
      </div>
      <Form onSubmit={handleSubmit} error={!!error}>
        <h2>Accedi al Gestionale</h2>

        {error && (
          <Message error header="Errore di autenticazione" content={error} />
        )}

        <Form.Field>
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Inserisci la tua Email"
            required
            disabled={isLoading}
            autoComplete="username"
          />
        </Form.Field>

        <Form.Field>
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Inserisci la tua Password"
            required
            disabled={isLoading}
            autoComplete="current-password"
          />
        </Form.Field>

        <Button type="submit" primary disabled={isLoading} fluid>
          {isLoading ? (
            <>
              <Loader active inline="centered" size="small" />
              Accesso in corso...
            </>
          ) : (
            "Accedi"
          )}
        </Button>
      </Form>
    </div>
  );
}
